export enum SortDirection {
    ASC,
    DESC,
}

export interface Sort {
    dataKey: string;
    sortDir: SortDirection;
}
